<template>
  <v-chip>
    <slot />
  </v-chip>
</template>

<style scoped lang="scss">
.v-chip {
  background-color: #F4F4F4;
  color: #000;
  font-weight: 500;
  :deep(.v-chip__underlay) {
    background-color: #F4F4F4;
  }
}
</style>